module.exports = __webpack_public_path__ + "img/logo.569e5c8d.png";